import Vue from "vue";
import configs from "../configs";
import Promise from "promise";
import queryString from "query-string";

const ip = configs.apiBase;

const retrieveTipos = ({ limit, offset, rows = 0 }) => {
  const pesquisa = queryString.stringify({ limit, offset, rows });
  return Vue.prototype.$http.get(`${ip}/empresa/v1/tipos?${pesquisa}`);
};

const retrieveTipoApuracao = (query) => {
  // console.log(query)
  return Vue.prototype.$http.get(
    `${ip}/empresa/v1/regime/estadual/apuracao/tipos?${queryString.stringify(query)}`,
  );
};

const retrieveCnaes = (pesquisa) => {
  return Vue.prototype.$http.post(`${ip}/empresa/v1/cnaes`, pesquisa);
};

const retrieve = ({
  usuario,
  listAll,
  limit,
  offset,
  rows,
  regimes,
  ativa,
  analise,
  fts = "",
}) => {
  const request = queryString.stringify(
    {
      limit,
      offset,
      rows,
      listAll,
      regimes,
      ativa,
      analise,
      fts: fts
        .split(" ")
        .filter((x, idx, arr) => x)
        .join("&"),
    },
    { arrayFormat: "bracket" },
  );
  return Vue.prototype.$http.get(
    `${ip}/empresa/v1/usuario/${usuario.basic.idUsuario}?${request}`,
  );
};

const retrieveEmpresa = ({ usuario, limit, offset, ativa, fts = "" }) => {
  const request = queryString.stringify(
    { limit, offset, ativa, fts },
    { arrayFormat: "bracket" },
  );
  return Vue.prototype.$http.get(
    `${ip}/empresa/v2/usuario/${usuario.basic.idUsuario}?${request}`,
  );
};

const pesquisaSimplesEmpresa = ({
  idUsuario,
  idEmpresa,
  cpfCnpj,
  fts = "",
}) => {
  let params = {};
  if (idEmpresa) params = { idEmpresa };
  if (cpfCnpj) params = { cpfCnpj };
  if (fts) params = { fts: fts.split(" ").join("&") };
  const request = queryString.stringify(params);
  return Vue.prototype.$http.get(
    `${ip}/empresa/v2/pesquisa/${idUsuario}?${request}`,
  );
};

const checkIfCompanyIsReferenced = ({ cpfCnpj, idEmpresa, idUsuario }) => {
  const request = queryString.stringify({ cpfCnpj, idEmpresa, idUsuario });
  return Vue.prototype.$http.get(
    `${ip}/empresa/v2/verifica/empresa/usuario?${request}`,
  );
};

const makeReference = ({ idEmpresa, idUsuario }) => {
  const request = queryString.stringify({ idEmpresa, idUsuario });
  return Vue.prototype.$http.post(
    `${ip}/empresa/v2/inserir/referencia/usuario?${request}`,
  );
};

const searchCompanyFts = ({ fts }) => {
  return Vue.prototype.$http.get(`${ip}/empresa/v2/pesquisa/fts/${fts}`);
};

const consultCompanyReceita = (cnpj) => {
  return Vue.prototype.$http.get(`${ip}/empresa/api/consult/company/${cnpj}`);
};

const retrieveCnaeV2 = ({ cnae }) => {
  return Vue.prototype.$http.get(`${ip}/empresa/v2/cnae/${cnae}`);
};

const pesquisaCompletaEmpresa = ({ idEmpresa }) => {
  const request = queryString.stringify({ idEmpresa });
  return Vue.prototype.$http.get(
    `${ip}/empresa/v2/pesquisa/completa?${request}`,
  );
};

const insert = (empresa) => {
  return Vue.prototype.$http.post(`${ip}/empresa/v2/`, empresa);
};

const update = (empresa) => {
  return Vue.prototype.$http.put(`${ip}/empresa/v1`, empresa);
};

const getRubricas = () => {
  return Vue.prototype.$http.get(`${ip}/empresa/v1/rubricas`);
};

const searchCnpjReceita = async (empresa) => {
  return new Promise(async (resolve, reject) => {
    try {
      const pesquisa = queryString.stringify({
        fts: empresa.cnpj,
        limit: 1,
        offset: 0,
        rows: 0,
      });
      const empresas = await Vue.prototype.$http.get(
        `${ip}/empresa/v1?${pesquisa}`,
      );
      if (empresas.body.data.length) {
        let err = {
          body: {
            message: "Empresa já cadastrada!",
            err: "A empresa que você está pesquisando já está cadastrada em nossa base de dados.",
          },
        };
        err.stack =
          "A empresa que você está pesquisando já está cadastrada em nossa base de dados.";
        throw err;
      } else {
        const responseReceita = await Vue.prototype.$http.get(
          `${ip}/cnpj/${empresa.cnpj}`,
        );
        resolve(Object.assign(empresa, responseReceita.body));
      }
    } catch (e) {
      reject(e);
    }
  });
};

const getRegimeFederal = ({ regime, vigencia }) => {
  return Vue.prototype.$http.get(
    `${ip}/empresa/v2/pesquisa/regime/${regime}/${vigencia}`,
  );
};

const getRegimeFederalByIdEmpresa = ({ idEmpresa }) => {
  return Vue.prototype.$http.get(
    `${ip}/empresa/v2/pesquisa/empresa/regime/${idEmpresa}`,
  );
};

const saveRegimeFederal = (payload) => {
  return Vue.prototype.$http.post(`${ip}/empresa/v2/regime/federal`, payload);
};

const updateEmpresaIE = ({ ie, idEmpresa }) => {
  return Vue.prototype.$http.put(
    `${ip}/empresa/v2/update/company/ie?ie=${ie}&idEmpresa=${idEmpresa}`,
  );
};

const updateSenhaContribuinte = ({ senhaContribuinte, idEmpresa }) => {
  return Vue.prototype.$http.put(
    `${ip}/empresa/v2/update/company/senhaContribuinte?senhaContribuinte=${senhaContribuinte}&idEmpresa=${idEmpresa}`,
  );
};

const updateEmpresaAtivo = ({ ativo, idEmpresa }) => {
  return Vue.prototype.$http.put(
    `${ip}/empresa/v2/update/company/ativo?ativo=${ativo}&idEmpresa=${idEmpresa}`,
  );
};

const updateGeneralInfo = (data) => {
  return Vue.prototype.$http.put(
    `${ip}/empresa/v2/update/general/company/info`,
    data,
  );
};

const updateCompanyAddress = (data) => {
  return Vue.prototype.$http.put(
    `${ip}/empresa/v2/update/company/address`,
    data,
  );
};

const updateCompanyContact = (data) => {
  return Vue.prototype.$http.put(
    `${ip}/empresa/v2/update/company/contact`,
    data,
  );
};

const searchCompanyOutorgado = ({ idEmpresa, vigencia }) => {
  const request = queryString.stringify({ idEmpresa, vigencia });
  return Vue.prototype.$http.get(
    `${ip}/empresa/v2/verifica/credito/outorgado?${request}`,
  );
};

const getOptionsOutorgado = () => {
  return Vue.prototype.$http.get(`${ip}/empresa/v2/opcoes/credito/outorgado`);
};

const insertCreditoOutorgado = (data) => {
  return Vue.prototype.$http.post(
    `${ip}/empresa/v2/inserir/credito/outorgado`,
    data,
  );
};

const insertContabilista = (data) => {
  return Vue.prototype.$http.post(
    `${ip}/empresa/v2/inserir/contabilista`,
    data,
  );
};

const retrieveLastContabilista = ({ idEmpresa }) => {
  const pesquisa = queryString.stringify({ idEmpresa });
  return Vue.prototype.$http.get(`${ip}/empresa/v2/contabilista?${pesquisa}`);
};

const retrieveFaturamento = ({ cpfCnpj, dtInicial, dtFinal, unificado }) => {
  const pesquisa = queryString.stringify({ cpfCnpj, dtInicial, dtFinal, unificado });
  return Vue.prototype.$http.get(`${ip}/empresa/v2/faturamento?${pesquisa}`);
};

export default {
  retrieveTipos,
  retrieveCnaes,
  retrieve,
  insert,
  update,
  getRubricas,
  searchCnpjReceita,
  retrieveTipoApuracao,
  retrieveEmpresa,
  pesquisaSimplesEmpresa,
  pesquisaCompletaEmpresa,
  getRegimeFederal,
  getRegimeFederalByIdEmpresa,
  saveRegimeFederal,
  updateEmpresaIE,
  updateSenhaContribuinte,
  updateEmpresaAtivo,
  checkIfCompanyIsReferenced,
  makeReference,
  searchCompanyFts,
  consultCompanyReceita,
  retrieveCnaeV2,
  updateGeneralInfo,
  updateCompanyAddress,
  updateCompanyContact,
  searchCompanyOutorgado,
  getOptionsOutorgado,
  insertCreditoOutorgado,
  insertContabilista,
  retrieveLastContabilista,
  retrieveFaturamento
};
